module.exports = vendor_c4263f414f60e1404fa8;